import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../actions/work_orders_actions';
import { WALKTHROUGHS_CRUD_ACTION_CREATORS } from '../actions/walkthroughs_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { CONTRACTOR_PROPS, ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';
import { flattenArrayValues, nullSafeGetOrElse } from '../utils/DataAccessUtils';
import {
	fetchAllMessagesSuccess,
	updateChannelInternalAttachments,
} from '../actions/messages_actions';
import { getInternalNotesChannelId } from '../utils/WorkOrderUtils';
import {
	applyInternalWorkspacePayloadToStore,
	fetchInternalWorkspaceForSupplier,
	mergeAndSortData,
	normalizeNotesResponse,
} from './messages_thunks';
import { workOrderSearchAndAPIAdaptor } from './work_orders_thunks_wrapper';
import { StoppedCreationCounts } from '../types/stopped_creation_counts';
import { DuplicateCandidateWithJudgement } from '../types/DuplicateJudgementTypes';

export const workOrdersRestCrudThunksForBuyer = new RestCrudThunks(
	'work_orders',
	'work_order',
	'workOrder',
	'workOrders',
	WORK_ORDERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);
export const workOrdersRestCrudThunksForSupplier = new RestCrudThunks(
	'work_orders',
	'work_order',
	'workOrder',
	'workOrders',
	WORK_ORDERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);
const fetchUtils = new FetchUtils();

const updateWorkOrderStatus = (workOrderStatus) => (roleType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_orders/status_update/${workOrderStatus}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

const planWorkOrder = updateWorkOrderStatus('plan');
export const planWorkOrderForBuyer = planWorkOrder(ROLE_TYPES.BUYER);
export const planWorkOrderForSupplier = planWorkOrder(ROLE_TYPES.SUPPLIER);

const startWorkOrder = updateWorkOrderStatus('start_work');
export const startWorkOrderForBuyer = startWorkOrder(ROLE_TYPES.BUYER);
export const startWorkOrderForSupplier = startWorkOrder(ROLE_TYPES.SUPPLIER);

const finishWorkOrder = updateWorkOrderStatus('finish_work');
export const finishWorkOrderForBuyer = finishWorkOrder(ROLE_TYPES.BUYER);
export const finishWorkOrderForSupplier = finishWorkOrder(ROLE_TYPES.SUPPLIER);

const cancelWorkOrder = updateWorkOrderStatus('cancelled');
export const cancelWorkOrderForBuyer = cancelWorkOrder(ROLE_TYPES.BUYER);
export const cancelWorkOrderForSupplier = cancelWorkOrder(ROLE_TYPES.SUPPLIER);

const reopenWorkOrder = updateWorkOrderStatus('reopen');
export const reopenWorkOrderForBuyer = reopenWorkOrder(ROLE_TYPES.BUYER);
export const reopenWorkOrderForSupplier = reopenWorkOrder(ROLE_TYPES.SUPPLIER);

const deferWorkOrder = updateWorkOrderStatus('deferred_for_budget');
export const deferWorkOrderForBuyer = deferWorkOrder(ROLE_TYPES.BUYER);
export const deferWorkOrderForSupplier = deferWorkOrder(ROLE_TYPES.SUPPLIER);

const snoozeWorkOrder = updateWorkOrderStatus('snoozed');
export const snoozeWorkOrderForBuyer = snoozeWorkOrder(ROLE_TYPES.BUYER);
export const snoozeWorkOrderForSupplier = snoozeWorkOrder(ROLE_TYPES.SUPPLIER);

const unsnoozeWorkOrder = updateWorkOrderStatus('undeferred');
export const unsnoozeWorkOrderForBuyer = unsnoozeWorkOrder(ROLE_TYPES.BUYER);
export const unsnoozeWorkOrderForSupplier = unsnoozeWorkOrder(ROLE_TYPES.SUPPLIER);

const reviewWorkOrderAndMarkComplete = updateWorkOrderStatus('work_reviewed_and_completed');
export const reviewWorkOrderAndMarkCompleteForBuyer = reviewWorkOrderAndMarkComplete(
	ROLE_TYPES.BUYER
);
export const reviewWorkOrderAndMarkCompleteForSupplier = reviewWorkOrderAndMarkComplete(
	ROLE_TYPES.SUPPLIER
);

const reviewWorkOrderAndMarkUnsatisfactory = updateWorkOrderStatus('work_unsatisfactory');
export const reviewWorkOrderAndMarkUnsatisfactoryForBuyer = reviewWorkOrderAndMarkUnsatisfactory(
	ROLE_TYPES.BUYER
);
export const reviewWorkOrderAndMarkUnsatisfactoryForSupplier = reviewWorkOrderAndMarkUnsatisfactory(
	ROLE_TYPES.SUPPLIER
);

const reviewInternalTechWorkOrderAndMarkComplete = updateWorkOrderStatus(
	'internal_tech_work_reviewed_and_completed'
);
export const reviewInternalTechWorkOrderAndMarkCompleteForBuyer =
	reviewInternalTechWorkOrderAndMarkComplete(ROLE_TYPES.BUYER);
export const reviewInternalTechWorkOrderAndMarkCompleteForSupplier =
	reviewInternalTechWorkOrderAndMarkComplete(ROLE_TYPES.SUPPLIER);

const markCompletedByThirdParty = updateWorkOrderStatus('mark_completed_by_supplier');
export const markCompletedByThirdPartyForSupplier = markCompletedByThirdParty(ROLE_TYPES.SUPPLIER);

const reviewInternalWorkOrderAndMarkUnresolved = updateWorkOrderStatus(
	'internal_tech_work_unresolved'
);
export const reviewInternalWorkOrderAndMarkUnresolvedForBuyer =
	reviewInternalWorkOrderAndMarkUnresolved(ROLE_TYPES.BUYER);

const techEnRouteWorkOrder = updateWorkOrderStatus('tech_en_route');

export const techEnRouteServiceCallForSupplier = techEnRouteWorkOrder(ROLE_TYPES.SUPPLIER);
export const techEnRouteServiceCallForBuyer = techEnRouteWorkOrder(ROLE_TYPES.BUYER);

const dismissWorkOrderNoteStatus =
	(roleType) =>
	({ workOrderId, noteText, noteAddedAtMillis }) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/work_order_notes/mark_not_awaiting_response`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.patch(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { workOrderId, noteText, noteAddedAtMillis },
					})
					.then(parseJSON)
					.then(({ json, status }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const dismissWorkOrderNoteStatusForBuyer = dismissWorkOrderNoteStatus(ROLE_TYPES.BUYER);
export const dismissWorkOrderNoteStatusForSupplier = dismissWorkOrderNoteStatus(
	ROLE_TYPES.SUPPLIER
);

const dismissWorkOrderNoteStatusForPath =
	(apiPath: string) =>
	(roleType) =>
	({ workOrderId, noteText, noteAddedAtMillis }) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/${apiPath}`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.patch(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { workOrderId, noteText, noteAddedAtMillis },
					})
					.then(parseJSON)
					.then(({ json, status }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

const dismissWorkOrderInternalNoteStatus = dismissWorkOrderNoteStatusForPath(
	'work_order/work_order_internal_space/mark_not_awaiting_response'
);
export const dismissWorkOrderInternalNoteStatusForBuyer = dismissWorkOrderInternalNoteStatus(
	ROLE_TYPES.BUYER
);
export const dismissWorkOrderInternalNoteStatusForSupplier = dismissWorkOrderInternalNoteStatus(
	ROLE_TYPES.SUPPLIER
);

// Contractor-note dismissal targets a contractor work order, not the parent WO,
// so the backend expects the id under `contractorWorkOrderId` rather than
// `workOrderId`. Caller still passes `workOrderId` for a uniform call site.
const dismissWorkOrderContractorNoteStatus =
	(roleType) =>
	({ workOrderId, noteText, noteAddedAtMillis }) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/contractor_work_order_notes/mark_not_awaiting_response`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.patch(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { contractorWorkOrderId: workOrderId, noteText, noteAddedAtMillis },
					})
					.then(parseJSON)
					.then(({ json, status }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};
export const dismissWorkOrderContractorNoteStatusForBuyer = dismissWorkOrderContractorNoteStatus(
	ROLE_TYPES.BUYER
);
export const dismissWorkOrderContractorNoteStatusForSupplier = dismissWorkOrderContractorNoteStatus(
	ROLE_TYPES.SUPPLIER
);

const downloadWorkOrderCSV =
	(roleType) =>
	(params, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/work_orders/csv_report_generator`;

		// if sorting present, fix order naming and add to query params

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							const hide = message.loading(d.data, 0);
							setTimeout(hide, 7000);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const downloadWorkOrderCSVForBuyer = downloadWorkOrderCSV(ROLE_TYPES.BUYER);
export const downloadWorkOrderCSVForSupplier = downloadWorkOrderCSV(ROLE_TYPES.SUPPLIER);

// entity must include id and notes fields
const updateWorkOrderNotes =
	(roleType) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/work_orders/update_notes`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.patch(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

export const updateWorkOrderNotesForBuyer = updateWorkOrderNotes(ROLE_TYPES.BUYER);
export const updateWorkOrderNotesForSupplier = updateWorkOrderNotes(ROLE_TYPES.SUPPLIER);

// Shared by the singular and bulk append endpoints — both return the same
// WorkOrderAppendNoteResponse and refresh the same slices.
const appendWorkOrderNotesRequest = (apiUrl, entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(
							WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess(
								nullSafeGetOrElse('data.workOrder', d, {})
							)
						);
						dispatch(
							fetchAllMessagesSuccess(
								entity.id,
								mergeAndSortData(nullSafeGetOrElse('data.workOrderNoteWithLog', d, {}))
							)
						);
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

// entity must include id and note fields
const appendWorkOrderNotes =
	(roleType) =>
	(entity, primaryKey = 'id') =>
		appendWorkOrderNotesRequest(
			`${getBackendUri()}/api/v2/${roleType}/work_order/work_orders/append_notes`,
			entity
		);

export const appendWorkOrderNotesForBuyer = appendWorkOrderNotes(ROLE_TYPES.BUYER);
export const appendWorkOrderNotesForSupplier = appendWorkOrderNotes(ROLE_TYPES.SUPPLIER);

// entity must include id and a notes array. Photo-only server-side, and it publishes a
// single grouped note notification for the whole batch instead of one per note.
// Mirrors WorkOrderCommonMethods.MaxNotesPerBulkAppend in openwrench-app; larger
// selections are sent as consecutive batches rather than rejected.
export const MAX_NOTES_PER_BULK_APPEND = 25;

const appendWorkOrderNotesBulk = (roleType) => (entity) =>
	appendWorkOrderNotesRequest(
		`${getBackendUri()}/api/v2/${roleType}/work_order/work_orders/append_notes/bulk`,
		entity
	);

export const appendWorkOrderNotesBulkForBuyer = appendWorkOrderNotesBulk(ROLE_TYPES.BUYER);
export const appendWorkOrderNotesBulkForSupplier = appendWorkOrderNotesBulk(ROLE_TYPES.SUPPLIER);

// Shared by the singular and bulk internal-note endpoints — both return the same
// envelope and refresh the same slices.
const appendInternalNotesRequest = (apiUrl, entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(
							WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess(
								nullSafeGetOrElse('data.workOrder', d, {})
							)
						);
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

// entity must include id and note fields
const appendInternalNotes =
	(roleType) =>
	(entity, primaryKey = 'id') =>
		appendInternalNotesRequest(
			`${getBackendUri()}/api/v1/${roleType}/work_order/work_order_internal_space/append_internal_notes`,
			entity
		);

export const appendInternalNotesForBuyer = appendInternalNotes(ROLE_TYPES.BUYER);
export const appendInternalNotesForSupplier = appendInternalNotes(ROLE_TYPES.SUPPLIER);

// entity must include id and a notes array. Photo-only server-side, and it publishes a
// single grouped note notification for the whole batch instead of one per note.
const appendInternalNotesBulk = (roleType) => (entity) =>
	appendInternalNotesRequest(
		`${getBackendUri()}/api/v1/${roleType}/work_order/work_order_internal_space/append_internal_notes/bulk`,
		entity
	);

export const appendInternalNotesBulkForBuyer = appendInternalNotesBulk(ROLE_TYPES.BUYER);
export const appendInternalNotesBulkForSupplier = appendInternalNotesBulk(ROLE_TYPES.SUPPLIER);

/**
 * Resolves authoritative attachment rows from PATCH .../attachments/update `data`.
 * Handles: { attachments }, { internalAttachments }, { workOrder }, or work order as `data`.
 */
const resolveAttachmentsFromAttachmentsPatchPayload = (d, fallbackAttachments) => {
	const data = nullSafeGetOrElse('data', d, null);
	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		return { list: fallbackAttachments || [], workOrder: null };
	}

	const wo = nullSafeGetOrElse('workOrder', data, null);

	if (Array.isArray(data.attachments)) {
		return { list: data.attachments, workOrder: wo || null };
	}
	if (Array.isArray(data.internalAttachments)) {
		return { list: data.internalAttachments, workOrder: wo || null };
	}
	if (wo && wo.id) {
		if (Array.isArray(wo.supplierInternalAttachments)) {
			return { list: wo.supplierInternalAttachments, workOrder: wo };
		}
		if (Array.isArray(wo.internalAttachments)) {
			return { list: wo.internalAttachments, workOrder: wo };
		}
	}
	if (data.id && Array.isArray(data.supplierInternalAttachments)) {
		return { list: data.supplierInternalAttachments, workOrder: data };
	}
	return { list: fallbackAttachments || [], workOrder: null };
};

/** Full internal-space merge only when PATCH includes a non-empty timeline (avoid wiping on notes: []). */
const internalSpaceEnvelopeHasTimeline = (payload) => {
	return (
		payload &&
		typeof payload === 'object' &&
		!Array.isArray(payload) &&
		((Array.isArray(payload.notes) && payload.notes.length > 0) ||
			(Array.isArray(payload.logs) && payload.logs.length > 0) ||
			(Array.isArray(payload.internalAttachmentLogs) && payload.internalAttachmentLogs.length > 0))
	);
};

// Internal Workspace Attachments — supplier side
// Updates attachments from PATCH response only (no follow-up GET). Syncs WO + messages channel for preview card.
export const updateInternalWorkspaceAttachmentsForSupplier = (obj: {
	id: string | number;
	attachments: any[];
}) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/work_order_internal_space/attachments/update`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart({ id: obj.id }));

			fetchUtils
				.patch(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: { id: parseInt(String(obj.id), 10), internalAttachments: obj.attachments },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json || {};
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (!ok || d.status === 'error') {
						const errMsg = d.message || 'Failed to update attachments.';
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(errMsg, { id: obj.id }));
						reject(errMsg);
						return;
					}

					const channelId = getInternalNotesChannelId(obj.id);
					const payloadEnvelope = nullSafeGetOrElse('data', d, {});

					if (internalSpaceEnvelopeHasTimeline(payloadEnvelope)) {
						dispatch(applyInternalWorkspacePayloadToStore(obj.id, payloadEnvelope));
						const nestedWo = nullSafeGetOrElse('workOrder', payloadEnvelope, null);
						if (nestedWo && nestedWo.id) {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess(nestedWo));
						}
						resolve(d.data);
						return;
					}

					const resolved = resolveAttachmentsFromAttachmentsPatchPayload(d, obj.attachments);
					const attachmentsForChannel = resolved.list;
					const workOrderFromServer = resolved.workOrder;

					if (workOrderFromServer && workOrderFromServer.id) {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess(workOrderFromServer));
					} else {
						dispatch(
							WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess({
								id: obj.id,
								supplierInternalAttachments: attachmentsForChannel,
							})
						);
					}
					dispatch(updateChannelInternalAttachments(channelId, attachmentsForChannel));
					dispatch(fetchInternalWorkspaceForSupplier(obj.id));
					resolve(d.data);
				})
				.catch((e) => {
					const errMsg = (e && e.message) || 'Failed to update attachments.';
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(errMsg, { id: obj.id }));
					reject(errMsg);
				});
		});
	};
};

const archiveWorkOrder =
	(roleType) =>
	(entity, primaryKey = 'id', showUndo = false) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/work_orders/archive`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

export const archiveWorkOrderForBuyer = archiveWorkOrder(ROLE_TYPES.BUYER);
export const archiveWorkOrderForSupplier = archiveWorkOrder(ROLE_TYPES.SUPPLIER);

const unarchiveWorkOrder =
	(roleType) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/work_orders/unarchive`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

export const unarchiveWorkOrderForBuyer = unarchiveWorkOrder(ROLE_TYPES.BUYER);
export const unarchiveWorkOrderForSupplier = unarchiveWorkOrder(ROLE_TYPES.SUPPLIER);

const confirmWorkOrder =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/confirm`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const declineWorkOrder =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/decline`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const declineWorkOrderPrivate =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/internal_tech/decline`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const transferWorkOrder =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/transfer`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
const subContractWorkOrder =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/sub_contract`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
export const updateContractWorkOrder = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/sub_contract`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
const removeSubContractWorkOrder =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/remove_sub_contract`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const transferWorkOrderPrivateSupplier =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/transfer`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const partsOrderedWorkOrder =
	(roleType) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/work_orders/status_update/parts_ordered`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const partsReceivedWorkOrder =
	(roleType) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/work_orders/status_update/parts_received`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const partsRequestedWorkOrder =
	() =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/work_orders/status_update/parts_requested`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

export const acceptWorkOrderForSupplier = confirmWorkOrder();
export const declineWorkOrderForSupplier = declineWorkOrder();
export const declineWorkOrderForPrivateSupplier = declineWorkOrderPrivate();
export const transferWorkOrderForSupplier = transferWorkOrder();
export const subContractWorkOrderForSupplier = subContractWorkOrder();
export const removeSubContractWorkOrderForSupplier = removeSubContractWorkOrder();

export const transferWorkOrderForPrivateSupplier = transferWorkOrderPrivateSupplier();

export const partsOrderedWorkOrderForBuyer = partsOrderedWorkOrder(ROLE_TYPES.BUYER);
export const partsOrderedWorkOrderForSupplier = partsOrderedWorkOrder(ROLE_TYPES.SUPPLIER);

export const partsReceivedWorkOrderForBuyer = partsReceivedWorkOrder(ROLE_TYPES.BUYER);
export const partsReceivedWorkOrderForSupplier = partsReceivedWorkOrder(ROLE_TYPES.SUPPLIER);

export const partsRequestedWorkOrderForSupplier = partsRequestedWorkOrder();

const scheduleServiceCall =
	(roleType) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/service_calls/status_update/tech_scheduled`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
export const scheduleServiceCallForSupplier = scheduleServiceCall(ROLE_TYPES.SUPPLIER);
export const scheduleServiceCallForBuyer = scheduleServiceCall(ROLE_TYPES.BUYER);

const rescheduleServiceCall =
	(roleType) =>
	(entity, primaryKey = 'id') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/work_order/service_calls/status_update/tech_rescheduled`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
export const rescheduleServiceCallForSupplier = rescheduleServiceCall(ROLE_TYPES.SUPPLIER);

export const manualCheckInServiceCallForSupplier = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/service_calls/status_update/remote_check_in`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const manualCheckOutServiceCallForSupplier = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/service_calls/status_update/remote_check_out`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const getDailyApikey = () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/buyer/videocalls/get_api_key`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

const getMeetingToken = (userType) => (roomName) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/live/meeting_id/` + roomName;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(window.btoa(d.data));
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getBuyerMeetingToken = (roomName) => getMeetingToken(ROLE_TYPES.BUYER)(roomName);
export const getSupplierMeetingToken = (roomName) => getMeetingToken(ROLE_TYPES.SUPPLIER)(roomName);

const owShortenedLink = (userType) => (longUrl) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/utility/shorten_url`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: {
						longUrl: longUrl,
					},
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 200) {
						resolve(d.data);
					} else {
						resolve(longUrl);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getBuyerOWShortenedLink = (longUrl) => owShortenedLink(ROLE_TYPES.BUYER)(longUrl);
export const getSupplierOWShortenedLink = (longUrl) =>
	owShortenedLink(ROLE_TYPES.SUPPLIER)(longUrl);

const owLiveShortenedLink = (userType) => (longUrl) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/utility/shorten_live_url`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: {
						longUrl: longUrl,
					},
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 200) {
						resolve(d.data);
					} else {
						resolve(longUrl);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

export const getBuyerOWLiveShortenedLink = (longUrl) =>
	owLiveShortenedLink(ROLE_TYPES.BUYER)(longUrl);
export const getSupplierOWLiveShortenedLink = (longUrl) =>
	owLiveShortenedLink(ROLE_TYPES.SUPPLIER)(longUrl);

const markNotificationSeen =
	(userType) =>
	(ids = []) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${userType}/notification/user_notifications/has_seen/${ids.join(',')}`;
		return (dispatch) => {
			return new Promise<void>((resolve, reject) => {
				fetchUtils
					.patch(baseUrl + apiUrl, {})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 200) {
							resolve(d.data);
						} else {
							resolve();
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const buyerMarkNotificationSeen = (ids) => markNotificationSeen(ROLE_TYPES.BUYER)(ids);
export const supplierMarkNotificationSeen = (ids) => markNotificationSeen(ROLE_TYPES.SUPPLIER)(ids);

const getCountByDisplayStatus = (userType) => (params) => {
	const baseUrl = getBackendUri();
	const url = `/api/v1/${userType}/work_order/work_orders/search/count_by_display_status`;
	return new Promise<void>((resolve, reject) => {
		fetchUtils
			.post(baseUrl + url, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				data: params,
			})
			.then(parseJSON)
			.then(({ json, status, ok }) => {
				const d = json;
				if (status === 200) {
					resolve(d.data);
				} else {
					resolve();
				}
			})
			.catch((d) => {
				console.log('d', d);
				reject(d.message);
			});
	});
};

export const getCountByDisplayStatusForBuyer = getCountByDisplayStatus(ROLE_TYPES.BUYER);
export const getCountByDisplayStatusForSupplier = getCountByDisplayStatus(ROLE_TYPES.SUPPLIER);

const getCountByStatus = (userType) => (params) => {
	const baseUrl = getBackendUri();
	const url = `/api/v1/${userType}/work_order/work_orders/search/count_by_status`;
	return new Promise<void>((resolve, reject) => {
		fetchUtils
			.post(baseUrl + url, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				data: params,
			})
			.then(parseJSON)
			.then(({ json, status, ok }) => {
				const d = json;
				if (status === 200) {
					resolve(d.data);
				} else {
					resolve();
				}
			})
			.catch((d) => {
				console.log('d', d);
				reject(d.message);
			});
	});
};

export const getCountByStatusForBuyer = getCountByStatus(ROLE_TYPES.BUYER);
export const getCountByStatusForSupplier = getCountByStatus(ROLE_TYPES.SUPPLIER);

const backDataWorkOrder = (userType) => (entity, reported_at) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/work_order/work_orders/${entity.id}/modify_reported_at?reportedAt=${reported_at}`;
	return (dispatch) => {
		return new Promise<void>((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
			fetchUtils
				.patch(baseUrl + apiUrl, {})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const backDataWorkOrderForSupplier = (id, reported_at) =>
	backDataWorkOrder(ROLE_TYPES.SUPPLIER)(id, reported_at);

const approveWorkOrderStatus = (workOrderStatus) => (roleType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_orders/status_update/${workOrderStatus}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
			fetchUtils
				.put(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
const approveWorkOrder = approveWorkOrderStatus('approved');
export const approveWorkOrderForBuyer = approveWorkOrder(ROLE_TYPES.BUYER);
export const approveWorkOrderForSupplier = approveWorkOrder(ROLE_TYPES.SUPPLIER);

export const getQuestionnaire =
	(userType) =>
	(id = []) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${userType}/work_order/review_questionnaire`;
		return (dispatch) => {
			return new Promise<void>((resolve, reject) => {
				fetchUtils
					.get(baseUrl + apiUrl, {})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 200) {
							resolve(d.data);
						} else {
							resolve();
						}
					})
					.catch((d) => {
						console.log('d', d);
						reject(d.message);
					});
			});
		};
	};

export const buyerGetQuestionnaire = (id) => getQuestionnaire(ROLE_TYPES.BUYER)(id);
export const supplierGetQuestionnaire = (id) => getQuestionnaire(ROLE_TYPES.SUPPLIER)(id);

export const submitQuestionnaire = (userType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/work_order/review_question_answer`;
	return (dispatch) => {
		return new Promise<void>((resolve, reject) => {
			fetchUtils
				.post(baseUrl + apiUrl, { data: entity })
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 200) {
						resolve(d.data);
					} else {
						resolve();
					}
				})
				.catch((d) => {
					console.log('d', d);
					reject(d.message);
				});
		});
	};
};

export const buyerSubmitQuestionnaire = (id) => submitQuestionnaire(ROLE_TYPES.BUYER)(id);
export const supplierSubmitQuestionnaire = (id) => submitQuestionnaire(ROLE_TYPES.SUPPLIER)(id);

export const getQuestionnaireByWorkOrder =
	(userType) =>
	(id = []) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${userType}/work_order/review_question_answer?workOrderId=${id}`;
		return (dispatch) => {
			return new Promise<void>((resolve, reject) => {
				fetchUtils
					.get(baseUrl + apiUrl, {})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 200) {
							resolve(d.data);
						} else {
							resolve();
						}
					})
					.catch((d) => {
						console.log('d', d);
						reject(d.message);
					});
			});
		};
	};

export const buyerGetQuestionnaireByWorkOrder = (id) =>
	getQuestionnaireByWorkOrder(ROLE_TYPES.BUYER)(id);
export const supplierGetQuestionnaireByWorkOrder = (id) =>
	getQuestionnaireByWorkOrder(ROLE_TYPES.SUPPLIER)(id);

export const syncWorkOrderApprovalHierarchy = (userType) => (entity, status) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			const baseUrl = getBackendUri();
			fetchUtils
				.patch(
					baseUrl +
						`/api/v1/${userType}/work_order/work_orders/approval_hierarchy_update/${entity.id}/status/${status}`,
					{}
				)
				.then((response: any) => response.json())
				.then((d) => {
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
export const syncWorkOrderApprovalHierarchyForBuyer = syncWorkOrderApprovalHierarchy('buyer');
export const syncWorkOrderApprovalHierarchyForSupplier = syncWorkOrderApprovalHierarchy('supplier');

export const bulkArchiveWorkOrders = (userType) => (filters) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			const baseUrl = getBackendUri();
			fetchUtils
				.post(baseUrl + `/api/v1/${userType}/work_order/work_orders/archive/bulk`, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: filters,
				})
				.then((response: any) => response.json())
				.then((d) => {
					const count = d && d.data;
					if (d.status === 'error') {
						reject(d.message);
						message.error(`${count} Failed to archive`);
					} else {
						resolve(d.data);
						message.success(`${count} Work Orders Archived`);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};

// Associates (or disassociates) an existing work order with a walkthrough task answer — the
// "link an existing work order" counterpart to creating one from a walkthrough task. The
// walkthrough <-> WO association lives in three stores (the WO's own walkthroughId /
// siteSurveyTaskTitleId columns behind the *CountAcrossWalkthroughs aggregations, the task
// answer's workOrderIds behind taskAnswers[].workOrders, and the association join row), and the
// plain WO update path writes none of them — so this dedicated endpoint is the only way to link
// after creation. `siteSurveyTaskTitleId` is free-form text, hence the body rather than the path.
//
// Single curried factory rather than ForBuyer/ForSupplier aliases (lessons #7): callers pass
// their own userType. The endpoint responds with the re-hydrated walkthrough — the same payload
// readOne returns — so this pushes it straight into the walkthroughs slice and callers need no
// follow-up fetch.
export const changeWalkthroughTaskWorkOrderLink =
	(userType) => (link: boolean) => (workOrderId, walkthroughId, siteSurveyTaskTitleId) => {
		const verb = link ? 'link_walkthrough_task' : 'unlink_walkthrough_task';
		const apiUrl = `/api/v1/${userType}/work_order/work_orders/${workOrderId}/${verb}`;
		return (dispatch) =>
			new Promise((resolve, reject) => {
				fetchUtils
					.patch(getBackendUri() + apiUrl, { data: { walkthroughId, siteSurveyTaskTitleId } })
					.then(parseJSON)
					.then(({ json, status }) => {
						if (status === 200) {
							dispatch(WALKTHROUGHS_CRUD_ACTION_CREATORS.fetchOneSuccess(json.data));
							resolve(json.data);
						} else {
							reject(nullSafeGetOrElse('message', json, 'Something went wrong'));
						}
					})
					.catch((error) => reject(error.message));
			});
	};

export const linkWalkthroughTaskWorkOrder = (userType) =>
	changeWalkthroughTaskWorkOrderLink(userType)(true);
export const unlinkWalkthroughTaskWorkOrder = (userType) =>
	changeWalkthroughTaskWorkOrderLink(userType)(false);

// One page of work orders from the search endpoint, plus the server-side total. Kept out of the
// work orders slice on purpose: every expanded walkthrough task runs its own query, and a shared
// target collection would have each task overwrite the others' results.
export const searchWorkOrdersWithCount =
	(userType) =>
	(filters, limit): Promise<{ workOrders: any[]; count: number }> => {
		const apiUrl = `/api/v1/${userType}/work_order/work_orders/search?offset=0&limit=${limit}`;
		return new Promise((resolve, reject) => {
			fetchUtils
				.post(getBackendUri() + apiUrl, { data: flattenArrayValues(filters) })
				.then(parseJSON)
				.then(({ json, status }) => {
					if (status === 200) {
						resolve({
							workOrders: workOrderSearchAndAPIAdaptor(nullSafeGetOrElse('data', json, [])),
							count: nullSafeGetOrElse('count', json, 0),
						});
					} else {
						reject(nullSafeGetOrElse('message', json, 'Something went wrong'));
					}
				})
				.catch((error) => reject(error.message));
		});
	};

export const linkWorkOrder =
	(userType) =>
	(baseWorkOrder = [], workOrderIds = [], linkWithPreExistingWorkOrders) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${userType}/work_order/work_order_link/${baseWorkOrder}`;
		return (dispatch) => {
			return new Promise<void>((resolve, reject) => {
				fetchUtils
					.post(baseUrl + apiUrl, {
						data: { workOrderIds, linkWithPreExistingWorkOrders },
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 200) {
							resolve(d.data);
						} else {
							resolve();
						}
					})
					.catch((d) => {
						console.log('d', d);
						reject(d.message);
					});
			});
		};
	};

export const linkWorkOrderForBuyer = (baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders) =>
	linkWorkOrder(ROLE_TYPES.BUYER)(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders);
export const linkWorkOrderForSupplier = (
	baseWorkOrder,
	workOrderIds,
	linkWithPreExistingWorkOrders
) => linkWorkOrder(ROLE_TYPES.SUPPLIER)(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders);

export const unLinkWorkOrder =
	(userType) =>
	(baseWorkOrder = [], workOrderIds = [], linkWithPreExistingWorkOrders) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${userType}/work_order/work_order_unlink/${baseWorkOrder}`;
		return (dispatch) => {
			return new Promise<void>((resolve, reject) => {
				fetchUtils
					.post(baseUrl + apiUrl, {
						data: { workOrderIds, linkWithPreExistingWorkOrders },
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 200) {
							resolve(d.data);
						} else {
							resolve();
						}
					})
					.catch((d) => {
						console.log('d', d);
						reject(d.message);
					});
			});
		};
	};

export const unLinkWorkOrderForBuyer = (
	baseWorkOrder,
	workOrderIds,
	linkWithPreExistingWorkOrders
) => unLinkWorkOrder(ROLE_TYPES.BUYER)(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders);
export const unLinkWorkOrderForSupplier = (
	baseWorkOrder,
	workOrderIds,
	linkWithPreExistingWorkOrders
) =>
	unLinkWorkOrder(ROLE_TYPES.SUPPLIER)(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders);

export const getReviewTags =
	(userType) =>
	(params = {}) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${userType}/review_tags`;
		return (dispatch) => {
			return new Promise<void>((resolve, reject) => {
				fetchUtils
					.get(baseUrl + apiUrl, { ...params })
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 200) {
							resolve(d.data);
						} else {
							resolve();
						}
					})
					.catch((d) => {
						console.log('d', d);
						reject(d.message);
					});
			});
		};
	};

export const buyerGetReviewTags = (params) => getReviewTags(ROLE_TYPES.BUYER)(params);
export const supplierGetReviewTags = (params) => getReviewTags(ROLE_TYPES.SUPPLIER)(params);

export const submitReview = (userType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/supplier_facility_reviews`;
	return (dispatch) => {
		return new Promise<void>((resolve, reject) => {
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 200) {
						resolve(d.data);
					} else {
						resolve();
					}
				})
				.catch((d) => {
					console.log('d', d);
					reject(d.message);
				});
		});
	};
};

export const buyerSubmitReview = (id) => submitReview(ROLE_TYPES.BUYER)(id);
export const supplierSubmitReview = (id) => submitReview(ROLE_TYPES.SUPPLIER)(id);

// Shared by the singular and bulk contractor-note endpoints — both return the same
// envelope and refresh the same slices.
const appendContractorWorkOrderNotesRequest = (apiUrl, entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						dispatch(
							fetchAllMessagesSuccess(
								entity.id,
								normalizeNotesResponse(nullSafeGetOrElse('data.notes', d, []))
							)
						);
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

// entity must include id and note fields
export const appendContractorWorkOrderNotes =
	(roleType) =>
	(entity, primaryKey = 'id') =>
		appendContractorWorkOrderNotesRequest(
			`${getBackendUri()}/api/v1/${roleType}/work_order/contractor_work_order_notes/append_notes`,
			entity
		);

// entity must include id and a notes array. Photo-only server-side, and it publishes a
// single grouped note notification for the whole batch instead of one per note.
export const appendContractorWorkOrderNotesBulk = (roleType) => (entity) =>
	appendContractorWorkOrderNotesRequest(
		`${getBackendUri()}/api/v1/${roleType}/work_order/contractor_work_order_notes/append_notes/bulk`,
		entity
	);

const updateContractorWOStatus =
	(status) =>
	(entity, contractorWOKey = CONTRACTOR_PROPS.FROM_WO) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/supplier/work_order/contractor_work_orders/${status}`;

		const subContractedFromWorkOrder = nullSafeGetOrElse(contractorWOKey, entity, {});

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: subContractedFromWorkOrder,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							const updatedWO = {
								...entity,
								[contractorWOKey]: d.data,
							};
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(updatedWO));
							resolve(updatedWO);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

export const acceptContractorWorkOrder = (entity) => updateContractorWOStatus('accept')(entity);
export const declineContractorWorkOrder = (entity) => updateContractorWOStatus('decline')(entity);
export const completeContractorWorkOrder = (entity) =>
	updateContractorWOStatus('completed')(entity);
export const cancelSelfClientWorkOrder = (entity) =>
	updateContractorWOStatus('cancelled')(entity, CONTRACTOR_PROPS.TO_WO);
export const approveSelfClientWorkOrder = (entity) =>
	updateContractorWOStatus('approved')(entity, CONTRACTOR_PROPS.TO_WO);
export const reopenContractorWorkOrder = (entity) =>
	updateContractorWOStatus('reopen')(entity, CONTRACTOR_PROPS.TO_WO);

export const techEnRouteContractorWorkOrder = (entity, contractorWOKey) =>
	updateContractorWOStatus('tech_en_route')(entity, contractorWOKey);
export const workUnsatisfactoryContractorWorkOrder = (entity, contractorWOKey) =>
	updateContractorWOStatus('work_unsatisfactory')(entity, contractorWOKey);

// Contractor Service calls
export const scheduleServiceCallForContractor = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/contractor_work_orders/contractor_service_calls/status_update/tech_scheduled`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
export const rescheduleServiceCallForContractor = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/contractor_work_orders/contractor_service_calls/status_update/tech_rescheduled`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
export const copyContractorServiceCall = (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/contractor_work_orders/contractor_service_calls/copy`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
export const manualCheckInServiceCallForContractor = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/contractor_work_orders/contractor_service_calls/status_update/remote_check_in`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const manualCheckOutServiceCallForContractor = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/contractor_work_orders/contractor_service_calls/status_update/remote_check_out`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const approveWorkOrderServiceCallForContractor = (entity, primaryKey = 'id') => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/supplier/work_order/contractor_work_orders/completed`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const associateAssetWithWorkOrder = (roleType) => (entity, id) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_orders/${id}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.createError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

// Each row's `hit` is one plain `find_duplicates` row, so it goes through the same adaptor; Jev's
// verdict rides along on the adapted work order as `duplicateJudgement`. Rows keep the backend's
// cosine order — `selectDuplicateWorkOrdersForDisplay` applies Jev's filter and rank.
const adaptDuplicateCandidatesWithJudgements = (rows: DuplicateCandidateWithJudgement[]) =>
	(rows || []).map(({ hit, judgement }) => ({
		...workOrderSearchAndAPIAdaptor([hit])[0],
		duplicateJudgement: judgement,
	}));

const findDuplicateWorkOrders = (userType) => (params) => {
	const baseUrl = getBackendUri();
	const url = `/api/v1/${userType}/work_order/work_orders/find_duplicates/with_judgements`;
	return new Promise((resolve, reject) => {
		fetchUtils
			.get(
				baseUrl + url,
				Object.assign(
					{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
					params
				)
			)
			.then(parseJSON)
			.then(({ json, status, ok }) => {
				if (status === 200) {
					resolve(adaptDuplicateCandidatesWithJudgements(json.data));
				} else {
					resolve([]);
				}
			})
			.catch((d) => {
				reject(d.message);
			});
	});
};

export const findDuplicateWorkOrdersForBuyer = findDuplicateWorkOrders(ROLE_TYPES.BUYER);
export const findDuplicateWorkOrdersForSupplier = findDuplicateWorkOrders(ROLE_TYPES.SUPPLIER);

export const findDuplicateWorkOrdersForCustomer = (params) => {
	const baseUrl = getBackendUri();
	const url = `/api/portal/work_order/work_orders/find_duplicates`;
	return new Promise((resolve, reject) => {
		fetchUtils
			.get(
				baseUrl + url,
				Object.assign(
					{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
					params
				)
			)
			.then(parseJSON)
			.then(({ json, status }) => {
				if (status === 200) {
					resolve(workOrderSearchAndAPIAdaptor(json.data));
				} else {
					resolve([]);
				}
			})
			.catch((d) => {
				reject(d.message);
			});
	});
};

export type WorkOrderSyncScope = {
	ids?: string;
	buyerCompanyIds?: string;
	syncAll?: boolean;
	parallelism?: number;
	batchSize?: number;
};

const buildWorkOrderSyncQueryString = (scope: WorkOrderSyncScope): string => {
	const parts: string[] = [];
	if (scope.ids) parts.push(`ids=${encodeURIComponent(scope.ids)}`);
	if (scope.buyerCompanyIds)
		parts.push(`buyerCompanyIds=${encodeURIComponent(scope.buyerCompanyIds)}`);
	if (scope.syncAll) parts.push(`syncAll=true`);
	if (scope.parallelism != null) parts.push(`parallelism=${scope.parallelism}`);
	if (scope.batchSize != null) parts.push(`batchSize=${scope.batchSize}`);
	return parts.join('&');
};

export const triggerWorkOrderOpenSearchSync = (scope: WorkOrderSyncScope) => () =>
	new Promise((resolve, reject) => {
		const query = buildWorkOrderSyncQueryString(scope);
		const apiUrl = `/api/v1/buyer/work_order/work_orders/sync_to_opensearch_dynamic?${query}`;
		fetchUtils
			.post(getBackendUri() + apiUrl, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then(({ json }) => {
				if (json.status === 'error') {
					reject(json.message);
				} else {
					resolve(json.data);
				}
			})
			.catch((e) => reject(nullSafeGetOrElse('message', e, 'Failed to start sync.')));
	});

export const fetchWorkOrderOpenSearchSyncStatus = () => () =>
	new Promise((resolve, reject) => {
		const apiUrl = `/api/v1/buyer/akka_stream_audits/status?entityType=OpenSearchSync_WorkOrder&isRunning=true`;
		fetchUtils
			.get(getBackendUri() + apiUrl, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then(({ json }) => {
				if (json.status === 'error') {
					reject(json.message);
				} else {
					resolve(json.data || []);
				}
			})
			.catch((e) => reject(nullSafeGetOrElse('message', e, 'Failed to fetch sync status.')));
	});

export const adjustWorkOrderSyncParallelism = (auditId: number, parallelism: number) => () =>
	new Promise((resolve, reject) => {
		const apiUrl =
			`/api/v1/buyer/akka_stream_audits/${auditId}/adjust_parallelism` +
			`?parallelism=${parallelism}`;
		fetchUtils
			.post(getBackendUri() + apiUrl, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then(({ json }) => {
				if (json.status === 'error') {
					reject(json.message);
				} else {
					resolve(json.data);
				}
			})
			.catch((e) => reject(nullSafeGetOrElse('message', e, 'Failed to adjust parallelism.')));
	});

export const cancelWorkOrderOpenSearchSync = (auditId: number) => () =>
	new Promise((resolve, reject) => {
		const apiUrl = `/api/v1/buyer/akka_stream_audits/${auditId}/cancel`;
		fetchUtils
			.post(getBackendUri() + apiUrl, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then(({ json }) => {
				if (json.status === 'error') {
					reject(json.message);
				} else {
					resolve(json.data);
				}
			})
			.catch((e) => reject(nullSafeGetOrElse('message', e, 'Failed to cancel sync.')));
	});

const sendPreCreationAttributes = (userType) => (payload) => {
	const baseUrl = getBackendUri();
	const url = `/api/v1/${userType}/work_order/work_orders/pre_creation_attributes`;
	return fetchUtils
		.post(baseUrl + url, {
			headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			data: payload,
		})
		.then(parseJSON)
		.then(({ json, status }) => {
			if (status === 200) return json;
			return null;
		})
		.catch(() => {});
};

export const sendPreCreationAttributesForBuyer = sendPreCreationAttributes(ROLE_TYPES.BUYER);
export const sendPreCreationAttributesForSupplier = sendPreCreationAttributes(ROLE_TYPES.SUPPLIER);

export const sendPreCreationAttributesForCustomer = (payload) => {
	const baseUrl = getBackendUri();
	const url = `/api/portal/work_order/work_orders/pre_creation_attributes`;
	return fetchUtils
		.post(baseUrl + url, {
			headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			data: payload,
		})
		.then(parseJSON)
		.then(({ json, status }) => {
			if (status === 200) return json;
			return null;
		})
		.catch(() => {});
};

const fetchStoppedCreationCounts = (userType: string, dispatch) => {
	const baseUrl = getBackendUri();
	const url = `/api/v1/${userType}/work_order/work_orders/pre_creation_attributes/stopped_creation_counts`;
	return new Promise<StoppedCreationCounts>((resolve, reject) => {
		fetchUtils
			.get(baseUrl + url, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then(({ json, status }) => {
				if (status === 401) {
					dispatch(logoutSuccess());
				}
				// `json` is absent when the response body was not JSON — parseJSON resolves the raw
				// Response in that case, so it has to be guarded before it is read.
				if (status === 200 && json && json.status !== 'error') {
					resolve(json.data);
				} else {
					reject(nullSafeGetOrElse('message', json, 'Unable to fetch stopped duplicate counts.'));
				}
			})
			.catch((error) =>
				reject(nullSafeGetOrElse('message', error, 'Unable to fetch stopped duplicate counts.'))
			);
	});
};

export const fetchStoppedCreationCountsForBuyer = () => (dispatch) =>
	fetchStoppedCreationCounts(ROLE_TYPES.BUYER, dispatch);
export const fetchStoppedCreationCountsForSupplier = () => (dispatch) =>
	fetchStoppedCreationCounts(ROLE_TYPES.SUPPLIER, dispatch);

const downloadStoppedCreationCountsCSV = (userType: string) => () => (dispatch) => {
	const baseUrl = getBackendUri();
	const url = `/api/v1/${userType}/work_order/work_orders/pre_creation_attributes/stopped_creation_counts/csv_report_generator`;
	return new Promise((resolve, reject) => {
		fetchUtils
			.get(baseUrl + url, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then(({ json, status }) => {
				if (status === 401) {
					dispatch(logoutSuccess());
				}
				// `json` is absent when the response body was not JSON; without this guard the deref
				// throws and the catch below surfaces the raw TypeError text to the user.
				if (!json || json.status === 'error') {
					// An error carries `message` and no `data` — the CSV job's reassurance text
					// only ever comes back on the success path.
					const errorMessage = nullSafeGetOrElse(
						'message',
						json,
						'Unable to export stopped duplicates.'
					);
					message.error(errorMessage);
					reject(errorMessage);
				} else {
					resolve(json.data);
					const hideLoadingMessage = message.loading(json.data, 0);
					setTimeout(hideLoadingMessage, 7000);
				}
			})
			.catch((error) => {
				const errorMessage = nullSafeGetOrElse(
					'message',
					error,
					'Unable to export stopped duplicates.'
				);
				message.error(errorMessage);
				reject(errorMessage);
			});
	});
};

export const downloadStoppedCreationCountsCSVForBuyer = downloadStoppedCreationCountsCSV(
	ROLE_TYPES.BUYER
);
export const downloadStoppedCreationCountsCSVForSupplier = downloadStoppedCreationCountsCSV(
	ROLE_TYPES.SUPPLIER
);
